import { render, staticRenderFns } from "./TitleBlock.vue?vue&type=template&id=a99b5ce8&scoped=true&"
import script from "./TitleBlock.vue?vue&type=script&lang=js&"
export * from "./TitleBlock.vue?vue&type=script&lang=js&"
import style0 from "./TitleBlock.vue?vue&type=style&index=0&id=a99b5ce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99b5ce8",
  null
  
)

export default component.exports